import { Article } from '~src/types/article'

const article: Article = {
  id: 5,
  date: 'Tue Oct 14 2021 16:05:47 GMT+0200 (Central European Summer Time)',
  title: 'Stale proszkowe',
  mainPicture: {
    type: 'img',
    src: 'powder',
    description: 'Proszek stalowy oglądany pod mikroskopem.',
    width: '100%',
    height: '500px',
  },
  content: [
    {
      type: 'p',
      content:
        'Niedawno w naszej ofercie pojawił się nowy gatunek stali - M390. Korzystając z tej okazji, możemy przyjrzeć się dokładniej różnicom, które występują między różnymi gatunkami stali używanych na ostrza.',
    },
    {
      type: 'p',
      content:
        'W stalach narzędziowych używanych na noże, próbuje się zwykle połączyć cechy, które wzajemnie się wykluczają. Sprowadza się to najczęściej do prób uzyskania maksymalnych twardości i odporności na ścieranie przy jednoczesnym zachowaniu odporności na złamania i wykruszenia. Najczęściej im stal twardsza i im więcej ma węglików, tym będzie bardziej krucha. Przy produkcji narzędzi szuka się ‘złotego środka’, w którym wytrzymałość stali jest wystarczająca, przy jednoczesnej możliwie małej stracie na twardości. Świadome wyważenie tych cech ma szczególnie duże znaczenie przy wykonywaniu narzędzi o bardzo małych przekrojach (jak noże), które są bardzo podatne na uszkodzenia mechaniczne.',
    },
    {
      type: 'p',
      content:
        'Często przy opisywaniu stali podaje się ich skład chemiczny, twardości, odporność na korozję i ścieranie. Natomiast jedną z bardzo ważnych cech stali, o którą mało kto pyta jest tzw. wielkość ziarna, czyli stopień rozdrobnienia podziałów układów krystalicznych i węglików w stali. W procesie produkcji i obróbki stali dąży się do osiągnięcia możliwie drobnego ziarna i możliwie małych węglików. Im one mniejsze tym większą odporność na wykruszenia i złamania otrzymamy w docelowym produkcie. Na wielkość ziarna ma wpływ wiele czynników: skład chemiczny, sposób odlewania, sposób obróbki termicznej i plastycznej w hucie, późniejsza obróbka w zakładach wytwarzających narzędzia…Ta cecha będzie decydująca w przypadku rozumienia różnic między stalami proszkowymi i konwencjonalnymi.',
    },
    {
      type: 'p',
      content: 'Warto zacząć od tego, jak wytwarza się stale narzędziowe.',
    },
    {
      type: 'p',
      content:
        'Większość stali narzędziowych, które są na rynku to stale odlewane ‘tradycyjnymi’ metodami hutniczymi, ciekły metal przelewany jest do wlewnic, w których stygnie - otrzymuje się w ten sposób wlewki. Przy stalach, w których wymagana jest większa czystość dodatkowo poddaje się je procesom rafinacji, które pozwalają na zmniejszenie ilości gazów i zanieczyszczeń w stopie. Tak przygotowany materiał przechodzi przez serię pras i walców, dzięki którym otrzymujemy pręty, płaskowniki i blachy - produkty w wielkości pozwalającej na wytwarzanie z nich narzędzi i części maszyn. Proces zgniatania i walcowania stali wpływa też korzystnie na rozdrobnienie ziarna w materiale, ujednolica też jakościowo ostateczne elementy.',
    },
    {
      type: 'p',
      content:
        'Tradycyjne metody produkcji stali pozwalają na osiągnięcie bardzo przyzwoitych materiałów, których właściwości są wystarczające na potrzeby większości wytwarzanych z nich narzędzi. Niemniej próby wytworzenia tradycyjnymi metodami materiałów o lepszych właściwościach (większej twardości i ilości węglików) kończyły się niepowodzeniami. Było to związane z ich bardzo dużą podatnością na rozrost ziaren i tworzenie dużych węglików, czego nie dało się zrównoważyć późniejszą obróbką plastyczną.',
    },
    {
      type: 'p',
      content:
        'W latach 1970 w USA pojawiła się nowa metoda produkcji stali wysokostopowych, która dała podstawy do rozwoju nowej rodziny stali - tzw. Stali proszkowych (RSP-RapidSolidifiedPowder Steel). W wypadku tego typu stali, roztopiony materiał wtryskiwany jest pod strumień sprężonego gazu(azotu), który powoduje jego momentalne krzepnięcie i tzw. atomizację. Ciekły metal zmienia się w bardzo drobny proszek stalowy, a średnica drobin tego pyłu i bardzo krótki czas jego krzepnięcia nie pozwala na wzrost większych struktur krystalicznych ani węglików. Tak przygotowany pył stalowy zbierany jest w cylindrycznych kolumnach a następnie zgrzewany w warunkach wysokiej temperatury i ciśnienia. Uzyskane w ten sposób ‘zgrzane’ bloki poddaje się obróbce plastycznej, podobnie jak w konwencjonalnych procesach produkcji. Z nich otrzymujemy pręty i blachy, gotowe do wyrobu narzędzi.',
    },

    {
      type: 'img',
      src: 'powder1',
      description:
        'Stal CruWear - wersja konwencjonalna. Wyraźnie widoczne duże skupiska węglików(białe plamki) rozmieszczone nierównomiernie.',
      width: '100%',
    },
    {
      type: 'img',
      src: 'powder2',
      description:
        'Stal CruWear - wersja proszkowa. Węgliki są znacznie mniejsze i regularnie rozlokowane w materiale.',
      width: '100%',
    },
    {
      type: 'p',
      content:
        'Mimo, że ich forma zewnętrzna jest taka sama, to rozdrobnienie ich sieci krystalicznej jest znacznie większe, a wielkość węglików nawet do 100 razy mniejsza, niż w tradycyjnych metodach produkcji. Proces ten pozwolił na stworzenie ‘super stali’, które pozwalają łączyć właściwości wysokostopowych gatunków trudnościeralnych, jednocześnie zapewniając dobrą odpornością na wykruszenia i złamanie. Kolejne generacje stali proszkowych przynosiły dodatkowe usprawnienia procesu - w tej chwili korzystamy ze stali trzeciej generacji. Jedną z nich jest właśnie M390 z serii MICROCLEAN (stale proszkowe znajdziecie też w rdzeniach naszych laminatów KŁOSYSanMai). Stale proszkowe są obecnie materiałami najbliższymi ideału jeśli chodzi o produkcję ostrzy. Przy czym należy pamiętać, że wszystkie materiały zawierające duże ilości węglików mają niższą udarność niż gatunki ‘prostsze’ stopowo i nie nadają się na narzędzia mające służyć do rąbania/uderzania. Przy wyborze materiału na maczetę, tasak albo nóż do pracy w ciężkich warunkach warto rozważyć gatunki o mniejszej ilości węglików i co za tym idzie - wyższej udarności. Natomiast w przypadku precyzyjnych cienkich ostrzy kuchennych stale proszkowe sprawdzają się świetnie.',
    },
    {
      type: 'p',
      content:
        'Wyśrubowane normy czystości chemicznej i skomplikowany proces wytwarzania sprawiają, że stale proszkowe są znacznie droższe od konwencjonalnych gatunków narzędziowych ( 2-3 krotnie). Niemniej trudnościeralne gatunki proszkowe stanowią współcześnie najlepsze dostępne materiały do wytwarzania wysokiej jakości ostrzy.',
    },

    {
      type: 'img',
      src: 'powder3',
      description: 'Narzędzia ze stali proszkowych (Bohler Edelstahl).',
      width: '100%',
    },
    {
      type: 'p',
      content:
        'Warto rozważyć wykorzystanie stali proszkowych w przypadku często używanych ostrzy - jak np. noże szefa kuchni / Santoku  - w takich nożach będziemy mieli szansę na wykorzystanie ich świetnych właściwości, a wysoka odporność na ścieranie zapewni dłuższe okresy pracy bez potrzeby ostrzenia.',
    },
  ],
}

export default article
